import React, { useState, useEffect, useCallback, useMemo } from "react";
// nodejs library that concatenates classes
// reactstrap components

import {
  Button,
  ListGroupItem,
  ListGroup,
  Row,
  Col,
  Container,
  NavbarBrand,
  Navbar,
  Card,
  CardHeader,
  CardBody,
  Form,
  Input,
  FormGroup,
  Label,
  Table,
} from "reactstrap";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  makeStyles,
  Backdrop,
  Fade,
  Modal,
} from "@material-ui/core";



import { ExpandMore } from "@material-ui/icons";

import { useHistory } from "react-router-dom";
import useAuth from "hooks/useAuth";
import { useApi, useTable } from "hooks";
import {
  permissionsService,
  userService,
} from "services";

import { BodyInfo } from "./components";
import SkeletonUserList from "./SkeletonUserList";
import NotifyComponent, { showNotify } from "components/notifications/notify";
import ManageUsers from ".";

const createStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "600px",
    margin: "auto auto",
    borderRadius: "10px",
    overflow: "hidden",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    width: "100%",
    overflow: "auto",
    padding: "0",
    borderRadius: "inherit",
  },
}));



const ListUsers = () => {
  const history = useHistory();
  const notifyRef = React.useRef(null);
  const { authorId, signOut } = useAuth();
  const currentAuthorId = authorId ? authorId.toString() : "";

  const [createModalState, setCreateModal] = useState(false);
  const openCreateModal = () => setCreateModal(true);
  const closeCreateModal = () => setCreateModal(false);
  const {
    data: usersResponse,
    loading: usersLoading,
    execute: fetchUsers,
  } = useApi(userService.list, { immediate: false });

  const {
    data: allPermissions,
    loading: permissionsLoading,
    execute: fetchPermissions,
  } = useApi(permissionsService.listUserPermissions, { immediate: false });

  const permissionsByUser = useMemo(() => {
    if (!allPermissions) return {};
    return allPermissions.reduce((acc, perm) => {
      const uid = perm.user_id;
      if (!acc[uid]) acc[uid] = [];
      acc[uid].push(perm);
      return acc;
    }, {});
  }, [allPermissions]);

  const isLoading = usersLoading || permissionsLoading;

  const {
    data: usersData,
    setData: setUsersData,
  } = useTable({ initialData: [] });

  useEffect(() => {
    if (usersResponse) {
      setUsersData(usersResponse);
    }
  }, [setUsersData, usersResponse]);

  const handleAuthFailure = useCallback(
    (error) => {
      if (error?.response) {
        showNotify(
          notifyRef,
          "Auth Error",
          error.response.data.detail,
          "danger"
        );
        signOut();
        history.push("/auth/login");
      } else {
        console.error(error);
      }
    },
    [history, notifyRef, signOut]
  );

  useEffect(() => {
    if (!authorId) {
      return;
    }

    const checkAdminPermission = async () => {
      try {
        const response = await userService.getById(authorId); // Chama a API para obter os dados do usuário
        const userData = response.data;

        if (!userData.is_superuser) {
          history.push("/admin"); // Redireciona para o dashboard ou outra página segura
        }
      } catch (error) {
        console.error("Erro ao verificar permissões do usuário:", error);
        signOut();
        history.push("/auth/login"); // Redireciona para login em caso de erro
      }
    };

    checkAdminPermission(); // Chama a função para verificar permissões
  }, [authorId, history, signOut]);

  const CreateModal = ({ ...props }) => {
    const classes = createStyles();
    return (
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={props.open}
          onClose={props.handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={props.open}>
            <div className={classes.paper}>
              <ManageUsers
                refresh={reloadData}
                close={props.handleClose}
                showNotify={showNotify}
                notifyRef={notifyRef}
              />
            </div>
          </Fade>
        </Modal>
      </div>
    );
  };

  useEffect(() => {
    fetchUsers().catch(handleAuthFailure);
    fetchPermissions().catch(console.error);
  }, [fetchUsers, fetchPermissions, handleAuthFailure]);

  const reloadData = (modal = false) => {
    Promise.all([fetchUsers(), fetchPermissions()])
      .catch(handleAuthFailure)
      .finally(() => {
        if (modal) closeCreateModal();
      });
  };

  const Users = ({ post, permission }) => {
    const [confirmDisable, setConfirmDisable] = useState(false);
    const openDisable = () => setConfirmDisable(true);
    const closeDisable = () => setConfirmDisable(false);

    const [editModalState, setEditModalState] = useState(false);
    const openModalEdit = () => setEditModalState(true);
    const closeModalEdit = () => setEditModalState(false);

    const [confirmPromotion, setConfirmPromotion] = useState(false);

    const promoteToAdmin = (userId) => {
      userService
        .update(userId, { is_superuser: true })
        .then(() => {
          showNotify(
            notifyRef,
            "Sucesso",
            "Usuário promovido a administrador com sucesso.",
            "success"
          );
          reloadData(); // Recarregar os dados após a atualização
        })
        .catch((error) => {
          showNotify(
            notifyRef,
            "Erro",
            `Falha ao promover o usuário a administrador: ${
              error.response?.data?.detail || error.message
            }`,
            "danger"
          );
          console.error("Erro ao promover a administrador:", error);
        });
    };

    const listStyle = {
      height: "40px",
      padding: "5px 15px",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      textTransform: "capitalize",
    };

    const AccordionMore = ({ data }) => {
      const [pages, setPages] = useState([]);

      const dateTimeJoined = data.post.date_joined.split("T");
      const dateJoined = dateTimeJoined[0].split("-");
      const dateTimeLastLogin =
        data.post.last_login != null ? data.post.last_login.split("T") : null;

      const dateLogin =
        dateTimeLastLogin != null ? dateTimeLastLogin[0].split("-") : null;
      const loginFormat =
        dateLogin === null
          ? "Never Loged In."
          : `${dateLogin[2]}/${dateLogin[1]}/${dateLogin[0]}`;

      useEffect(() => {
        let abortController = new AbortController();
        const getPages = () => {
          if (permission[0] === undefined) return;
          permissionsService
            .getById(permission[0].idPermission)
            .then((response) => setPages(response.data))
            .catch(console.error);
        };

        getPages();
        return () => abortController.abort();
      }, [permission]);
      const GetPage = ({ post }) => {
        const [pageName, setPageName] = useState([]);
        useEffect(() => {
          let abortController = new AbortController();
          const getPage = () => {
            permissionsService
              .getPageById(post[0])
              .then((response) => setPageName(response.data))
              .catch(console.error);
          };
          getPage();
          return () => abortController.abort();
        }, [post]);

        return <ListGroupItem style={listStyle}>{pageName.name}</ListGroupItem>;
      };
      const PageItem = ({ ...props }) => {
        let pages = props.pages;
        const pagesGroups = pages.idPages.split(",");
        pages = [];
        pagesGroups.forEach((page) => {
          pages.push(page.split("."));
        });
        return (
          <div>
            <ListGroupItem
              style={{
                minHeight: "40px",
                height: "auto",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "0",
              }}
            >
              <Accordion
                style={{
                  width: "100%",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  style={{
                    width: "100%",
                    marginLeft: "auto",
                    marginRight: "auto",
                    boxShadow: "none",
                    borderBottom: "1px solid #e9ecef"
                  }}
                >
                  {props.pages.name}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "10px",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "0.5rem",
                      boxShadow: "0 1px 3px rgba(50, 50, 93, 0.15)",
                      border: "1px solid #e9ecef",
                      overflow: "hidden"
                    }}
                  >
                    <ListGroupItem className="active">Páginas:</ListGroupItem>
                    {pages.map((data, index) => (
                      <GetPage key={`pageItem-${index}`} post={data} />
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </ListGroupItem>
          </div>
        );
      };

      return (
        <div
          style={{
            width: "100%",
            minHeight: "100px",
            height: "auto",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "10px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              boxSizing: "border-box",
              padding: "15px",
            }}
          >
            <div
              style={{
                width: "100%",
                borderRadius: "0.5rem",
                boxShadow: "0 1px 3px rgba(50, 50, 93, 0.15)",
                backgroundColor: "#fff",
                overflow: "hidden",
                border: "1px solid #e9ecef"
              }}
            >
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" className="px-4">Nome</th>
                    <th scope="col">Usuário</th>
                    <th scope="col">Email</th>
                    <th scope="col">Entrou</th>
                    <th scope="col">Último Login</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row" className="px-4">
                      <div className="d-flex align-items-center">
                        <span className="mb-0 text-sm font-weight-600" style={{ color: "#172430" }}>
                          {data.post.first_name !== ""
                            ? `${data.post.first_name} ${data.post.last_name}`
                            : data.post.username}
                        </span>
                      </div>
                    </th>
                    <td>
                      <span className="mb-0 text-sm" style={{ color: "#525f7f" }}>
                        {data.post.username}
                      </span>
                    </td>
                    <td>
                      <span className="mb-0 text-sm" style={{ color: "#525f7f" }}>
                        {data.post.email}
                      </span>
                    </td>
                    <td>
                      <span className="mb-0 text-sm" style={{ color: "#525f7f" }}>
                        {dateJoined[2]}/{dateJoined[1]}/{dateJoined[0]}
                      </span>
                    </td>
                    <td>
                      <span className="mb-0 text-sm" style={{ color: "#525f7f" }}>{loginFormat}</span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
          {pages.length === undefined ? (
            <BodyInfo>
              <ListGroup
                style={{
                  boxShadow: "0px 0px 3px black",
                  // border: "1px solid black",
                  borderRadius: "5px",
                  overflow: "hidden",
                }}
              >
                <ListGroupItem className="active" style={listStyle}>
                  Permission:
                </ListGroupItem>
                <PageItem pages={pages} />
              </ListGroup>
            </BodyInfo>
          ) : null}
        </div>
      );
    };

    const ModalEdit = ({ ...props }) => {
      const [selected] = useState(
        permission.length > 0 ? permission[0].idPermission : ""
      );
      const [permissions, setPermissions] = useState([]);


      const classes = createStyles();
      const userData = {
        first_name: props.post.first_name,
        last_name: props.post.last_name,
        username: props.post.username,
        email: props.post.email,
        groups: props.post.groups,
        is_superuser: props.post.is_superuser,
      };

      useEffect(() => {
        let abortController = new AbortController();
        const getPermissions = () => {
          permissionsService
            .list()
            .then((response) => setPermissions(response.data))
            .catch(console.error);
        };

        getPermissions();
        return () => abortController.abort();
      }, []);

      const updateInfo = async (e) => {
        e.preventDefault();

        userData.first_name = document.getElementById("first_name").value;
        userData.last_name = document.getElementById("last_name").value;
        userData.username = document.getElementById("username").value;
        userData.email = document.getElementById("email").value;
        userData.permission = selected;
        userData.is_superuser = post.is_superuser;

        // Captura o valor do campo de senha
        const newPassword = document.getElementById("new_password").value;

        try {
          // Atualiza os dados do usuário
          await userService.update(post.id, userData);

          // Se uma nova senha foi fornecida, faz a chamada para mudar a senha
          if (newPassword) {
            await userService.setPassword(post.id, {
              new_password: newPassword,
            });
          }

          showNotify(
            notifyRef,
            "Sucesso na atualização",
            "O usuário foi atualizado com Sucesso",
            "success"
          );
          closeModalEdit();
          reloadData();
        } catch (error) {
          console.error(error);
        }
      };

      const UserForm = () => {


        const [confirmSave, setConfirmSave] = useState(false);

        return (
          <>
            <Navbar
              className="navbar-horizontal navbar-dark bg-default"
              expand="lg"
              style={{
                width: "100%",
                height: "50px",
              }}
            >
              <Container>
                <NavbarBrand style={{ cursor: "default", userSelect: "none" }}>
                  Editar Informação
                </NavbarBrand>
                <Button
                  color="danger"
                  size="sm"
                  type="button"
                  onClick={closeModalEdit}
                >
                  Fechar
                </Button>
              </Container>
            </Navbar>
            <Form
              onSubmit={updateInfo}
              style={{
                padding: "15px",
              }}
            >
              <Label>Nome:</Label>
              <FormGroup
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Input
                  placeholder="First Name"
                  id="first_name"
                  type="text"
                  defaultValue={post.first_name}
                  style={{ width: "45%" }}
                />
                <Input
                  placeholder="Last Name"
                  id="last_name"
                  type="text"
                  defaultValue={post.last_name}
                  style={{ width: "45%" }}
                />
              </FormGroup>
              <Label>Usuário:</Label>
              <FormGroup>
                <Input
                  placeholder="Your new Username is..."
                  defaultValue={post.username}
                  required
                  type="text"
                  id="username"
                />
              </FormGroup>
              <Label>E-mail:</Label>
              <FormGroup>
                <Input
                  placeholder="Your new Email is..."
                  required
                  defaultValue={post.email}
                  type="email"
                  id="email"
                />
              </FormGroup>
              <Label>Senha:</Label>
              <FormGroup>
                <Input
                  placeholder="Nova senha"
                  type="password"
                  id="new_password"
                />
              </FormGroup>
              {/* <div style={{
                                width: '100%'
                            }}>
                                {post.is_superuser?null:(
                                    <FormControl variant="outlined" required className={classes.formControl}>
                                        <InputLabel id="demo-simple-select-outlined-label">Permissão</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={selected}
                                            onChange={handleChange}
                                            label="Permission"
                                        >
                                                <MenuItem value="">
                                                <em>Nenhum</em>
                                                </MenuItem>
                                                {permissions.map((data, index) => (<MenuItem key={`permission-${index}`} value={data.idPermission}>{data.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                )}
                            </div> */}
              {confirmSave ? (
                <Button
                  color="success"
                  type="button"
                  onClick={(e) => {
                    updateInfo(e);
                    setConfirmSave(false);
                  }}
                  onMouseOut={() => setConfirmSave(false)}
                  style={{ float: "right", marginBottom: "15px" }}
                >
                  Confirmar
                </Button>
              ) : (
                <Button
                  color="primary"
                  type="button"
                  onClick={() => setConfirmSave(true)}
                  style={{ float: "right", marginBottom: "15px" }}
                >
                  Salvar
                </Button>
              )}
            </Form>
          </>
        );
      };

      return (
        <div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={props.open}
            onClose={props.close}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <div className={classes.paper}>
              <UserForm />
            </div>
          </Modal>
        </div>
      );
    };

    const disableUser = (e) => {
      e.target.disabled = true;
      userService
        .update(post.id, { is_active: "false" })
        .then(() => {
          showNotify(
            notifyRef,
            "User Disable",
            "Success to disable this user.",
            "success"
          );
          reloadData();
        })
        .catch(console.error);
    };

    const enableUser = (e) => {
      e.target.disabled = true;
      userService
        .update(post.id, { is_active: "true" })
        .then(() => {
          showNotify(
            notifyRef,
            "User Enable",
            "Success to enable this user.",
            "success"
          );
          reloadData();
        })
        .catch(console.error);
    };

    return (
      <ListGroupItem
        className="px-0"
        style={{
          borderRadius: "10px",
        }}
      >
        <Accordion
          style={{
            borderRadius: "0.5rem",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(50, 50, 93, 0.15)",
            border: "1px solid #e9ecef"
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            style={{
              borderBottom: "1px solid #e9ecef",
            }}
          >
            <div
              className="col ml--2"
              style={{
                width: "100%",
                height: "inherit",
                paddingLeft: "50px",
              }}
            >
              <h4 className="mb-0">
                {post.username}&nbsp;
                {post.id.toString() === currentAuthorId ? "(you)" : ""}
              </h4>
              <small style={{ color: "#525f7f" }}>
                {post.first_name !== ""
                  ? `${post.first_name} ${post.last_name}`
                  : post.username}
              </small>
            </div>
            {post.is_superuser ? null : (
              <>
                {/* Botão de Promoção */}
                <FormControlLabel
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  style={{ margin: "0", position: "relative" }}
                  control={
                    <Col
                      className="col-auto"
                      style={{
                        padding: "0",
                        marginRight: "10px",
                        display: "flex",
                        gap: "5px",
                        position: "relative",
                      }}
                    >
                      {confirmPromotion ? (
                        <Button
                          color="success"
                          outline
                          size="sm"
                          type="button"
                          onClick={() => {
                            promoteToAdmin(post.id);
                            setConfirmPromotion(false);
                          }}
                          onMouseOut={() => setConfirmPromotion(false)}
                          style={{ width: "140px" }}
                        >
                          Confirmar
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          outline
                          size="sm"
                          type="button"
                          onClick={() => setConfirmPromotion(true)}
                        >
                          Promover a Admin
                        </Button>
                      )}
                    </Col>
                  }
                />

                {/* Botão de Edição */}
                <FormControlLabel
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  style={{ margin: "0" }}
                  control={
                    <Col
                      className="col-auto"
                      style={{ padding: "0", marginRight: "10px" }}
                    >
                      <Button
                        color="primary"
                        outline
                        size="sm"
                        type="button"
                        onClick={openModalEdit}
                        disabled={
                          post.id.toString() === currentAuthorId
                        }
                      >
                        Editar
                      </Button>
                      <ModalEdit
                        open={editModalState}
                        close={closeModalEdit}
                        post={post}
                      />
                    </Col>
                  }
                />

                {/* Botão de Ativação/Desativação */}
                <FormControlLabel
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  style={{ margin: "0" }}
                  control={
                    <Col className="col-auto" style={{ padding: "0" }}>
                      {post.is_active === true ? (
                        <Button
                          color="danger"
                          outline
                          size="sm"
                          type="button"
                          onClick={confirmDisable ? disableUser : openDisable}
                          onMouseOut={closeDisable}
                        >
                          {confirmDisable ? "Confirmar" : "Desabilitar"}
                        </Button>
                      ) : (
                        <Button
                          color="success"
                          outline
                          size="sm"
                          type="button"
                          onClick={enableUser}
                        >
                          Ativar
                        </Button>
                      )}
                    </Col>
                  }
                />
              </>
            )}
          </AccordionSummary>
          <AccordionDetails style={{ backgroundColor: "#C2641A" }}>
            <AccordionMore data={{ post }} />
          </AccordionDetails>
        </Accordion>
      </ListGroupItem>
    );
  };

  return (
    <div className="content">
      <Container fluid>
        <NotifyComponent notifyRef={notifyRef} />
        
        <Row className="mb-4 align-items-center">
          <Col md="8">
            <h2 className="mb-0 text-dark" style={{ fontWeight: "700" }}>
              <i className="ni ni-circle-08 text-primary mr-2" />
              Gestão de Acessos e Usuários
            </h2>
            <p className="text-muted mb-0 small">Administre as contas dos usuários, permissões e níveis de acesso ao sistema.</p>
          </Col>
          <Col md="4" className="text-right">
            <Button
              color="primary"
              size="sm"
              type="button"
              onClick={openCreateModal}
              className="px-4 shadow-sm"
            >
              <i className="ni ni-fat-add mr-1" />
              Novo Usuário
            </Button>
            <CreateModal open={createModalState} handleClose={closeCreateModal} />
          </Col>
        </Row>

        <Row>
          <Col>
            <Card className="shadow-sm border-0">
              <CardHeader className="bg-transparent border-0 py-3">
                <h4 className="mb-0 text-muted font-weight-600">Usuários Cadastrados</h4>
              </CardHeader>
              <CardBody className="p-0">
                {isLoading ? (
                  <SkeletonUserList />
                ) : (
                  <div className="px-3 pb-3">
                    <ListGroup
                      className="list"
                      flush
                      style={{
                        width: "100%",
                        borderRadius: "0.5rem",
                        overflow: "hidden",
                        border: "1px solid #e9ecef"
                      }}
                    >
                      <div
                        style={{
                          overflowY: "auto",
                          maxHeight: "65vh",
                          padding: "2px",
                        }}
                      >
                        {usersData.length > 0 ? (
                          usersData.map((data, index) => (
                            <Users key={`userlist-${index}`} post={data} permission={permissionsByUser[data.id] || []} />
                          ))
                        ) : (
                          <div className="text-center py-5">
                            <i className="ni ni-single-02 display-3 text-muted opacity-3 mb-3" />
                            <h4 className="text-muted">Nenhum usuário encontrado.</h4>
                          </div>
                        )}
                      </div>
                    </ListGroup>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListUsers;
